import { connect } from 'react-redux';

import { goToLink } from 'redux-core/router/actions';
import { openDocument360Tab } from 'redux-core/dialogs/actions';

const mapDispatchToProps = { goToLink, openDocument360Tab };

export default connect(undefined, mapDispatchToProps);
